import { FormControlLabel, Switch } from "@mui/material";
import { SubGraphOperatorFieldWrapper, SelectEl } from "../style/SubGraphOperator.styled";

const viewSize = [5, 10, 20, 30];

export default function SubGraphOperatorFieldView({
    checkedSwitch,
    onActionChangeSwitch,
    optionListSize,
    onActionChangeOptionListSize
}) {
    return (
        <SubGraphOperatorFieldWrapper>
            <div className='toggle-group'>
                <FormControlLabel labelPlacement="start" control={<Switch checked={checkedSwitch} onChange={() => onActionChangeSwitch()} />} label="주문 데이터 표시" />
            </div>
            <div>
                <SelectEl onChange={(e) => onActionChangeOptionListSize(e)} value={optionListSize}>
                    {viewSize.map((r, idx) => {
                        return (
                            <option key={'view-option-idx' + idx} value={r}>{`${r}위 확인`}</option>
                        )
                    })}
                </SelectEl>
            </div>
        </SubGraphOperatorFieldWrapper>
    )
}